import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import DashBoard from '@/api/dashboard/api-dashboard';
import { getCompanyID, getEmployeeID } from '@/helpers/Utils';
import { apiPath, firstListItem } from '@/constants/defaultValues';
import { Delete, Get, Post, Put } from '@/api/api-middleware';

const employeeData = {
  name: 'Venkatesh Deva',
  designation: 'UI Designer',
  email: 'Breat-johnson@gmail.com',
  phone: '+1-555-0124',
  employeeNo: 'D00433',
  department: 'Products and Service',
  location: 'Main office - (Abu Dhabi)',
  flexibleShift: '8:00 AM to 9:00 AM - 5:00 AM to 6:00 PM',
  image: null,
  manager: {
    name: 'Shafeeq Ahmed Akbar',
    designation: 'Products Head',
    image: null,
  },
  contact: {
    email: 'Kevin-green26@stsupreme.com',
    phone: '+1-555-0124',
    department: 'Products & Services ',
  },
};

const dummyDailyOverview = [
  {
    label: 'Clock In Time',
    value: '9:00 AM',
    color: 'green',
    icon: 'clockIcon',
    fullWidth: false,
  },
  {
    label: 'Expected Out',
    value: '6:00 PM',
    color: 'maroon',
    icon: 'logoutIcon',
    fullWidth: false,
  },
  {
    label: 'In Office',
    value: '9:00 AM',
    color: 'blue-light',
    icon: 'officeIcon',
    fullWidth: false,
  },
  {
    label: 'Late In',
    value: '9:05 AM',
    color: 'orange-deep',
    icon: 'lateInIcon',
    fullWidth: false,
  },
  {
    label: 'Early Out ',
    value: '5:40 PM',
    color: 'purple',
    icon: 'earlyOutIcon',
    fullWidth: false,
  },
  {
    label: 'Work Hours',
    value: '8h 35m',
    color: 'pink',
    icon: 'workHoursIcon',
    fullWidth: false,
  },
  {
    label: 'Flexible Shift In Time & Shift Out Time',
    value: '8:00 AM to 5:00 AM - 9:00 AM to 6:00 PM',
    color: 'light-green',
    icon: 'shiftInOutIcon',
    fullWidth: true,
  },
];

const initialState = {
  employeeDetails: { data: null, loading: false, error: null },
  dashboardCard: {
    data: null,
    loading: false,
    error: null,
  },
  dailyOverview: {
    data: [],
    loading: false,
    error: null,
  },

  quickActions: {
    violations: { data: [], loading: false, error: null },
    transactions: { data: [], loading: false, error: null },
    leaves: { data: [], loading: false, error: null },
    exception: { data: [], loading: false, error: null },
    remoteWork: { data: [], loading: false, error: null },
    currentTab: 'violations',
  },
  calendarData: {
    data: null,
    loading: false,
    error: null,
  },

  dashBoardDetails: {},
  dashboardDetailsItem: {},
  dashboardDayDetailsItem: {},
  dashboardBasicDetails: {},
  dashboardPopUpData: [],
  // dashboardCard: [],
  loading: false,
  error: '',
  notification: 0,
};

export const fetchDashBoardDetails = createAsyncThunk(
  'dashboard/fetchDashBoardDetails',
  async (params, thunkAPI) => {
    try {
      const { month, day, year } = params;
      const response = await DashBoard.GetAllDashBoardDetails({
        companyID: getCompanyID(),
        month,
        year,
        day,
        employeeID: getEmployeeID(),
        employeeNo: '',
      });
      return response?.data?.data;
    } catch (error) {
      console.log(error);
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

export const GetEmployeeDashboardData = createAsyncThunk(
  'dashboard/GetEmployeeDashboardData',
  async (params, thunkAPI) => {
    try {
      const response = await Post({
        url: `${apiPath}${'api/Operations/Employee/GetDashboardData'}`,
        data: params,
      });
      return response?.data?.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

export const GetEmployeeDashboardDayDetails = createAsyncThunk(
  'dashboard/GetEmployeeDashboardDayDetails',
  async (params, thunkAPI) => {
    try {
      const response = await Post({
        url: `${apiPath}${'api/Operations/Employee/GetDashboardData_Day'}`,
        data: params,
      });
      return response?.data?.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

export const GetCardPopupData = createAsyncThunk(
  'dashboard/GetCardPopupData',
  async (params, thunkAPI) => {
    try {
      const response = await Post({
        url: `${apiPath}${'api/Operations/Employee/GetDashboardPopupData'}`,
        data: params,
      });
      return response?.data?.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

export const MoveGateTransactionToReaderTransaction = createAsyncThunk(
  'dashboard/MoveGateTransactionToReaderTransaction',
  async (params, thunkAPI) => {
    try {
      const response = await Post({
        url: `${apiPath}${'api/Operations/Transactions/MoveGateTransactionToReader'}`,
        data: {
          companyID: getCompanyID(),
          employeeID: getEmployeeID(),
          transactionID: params?.id,
        },
      });
      return response?.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

export const fetchEmployeeDetails = createAsyncThunk(
  'dashboard/fetchEmployeeDetails',
  async () => {
    try {
      const result = await new Promise((resolve) => {
        setTimeout(() => {
          resolve(employeeData);
        }, 500);
      });

      return result;
    } catch (error) {
      throw error;
    }
  }
);

// export const fetchEmployeeDetails = createAsyncThunk(
//   'dashboard/fetchEmployeeDetails',
//   async (_, thunkAPI) => {
//     try {
//       const response = await axios.get('/api/employee/details');
//       return response.data;
//     } catch (error) {
//       return thunkAPI.rejectWithValue(error.response?.data?.message || error.message);
//     }
//   }
// );

export const fetchDashboardCard = createAsyncThunk(
  'dashboard/fetchDashboardCard',
  async (_, thunkAPI) => {
    try {
      const sampleCards = [
        { title: 'Leaves', count: 5 },
        { title: 'Late Arrivals', count: 2 },
      ];
      return await new Promise((resolve) =>
        setTimeout(() => resolve(sampleCards), 500)
      );
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.message || 'Failed to load dashboard cards'
      );
    }
  }
);

export const fetchQuickActionsData = createAsyncThunk(
  'dashboard/fetchQuickActionsData',
  async ({ tab, params }, thunkAPI) => {
    try {
      let endpoint = '';
      const baseParams = {
        companyID: getCompanyID(),
        employeeID: getEmployeeID(),
        ...params,
      };

      // Set endpoint based on tab
      switch (tab) {
        case 'violations':
          endpoint = 'api/Operations/Employee/GetViolationsData';
          break;
        case 'transactions':
          endpoint = 'api/Operations/Employee/GetTransactionsData';
          break;
        case 'leaves':
          endpoint = 'api/Operations/Employee/GetLeavesData';
          break;
        case 'exception':
          endpoint = 'api/Operations/Employee/GetExceptionData';
          break;
        case 'remoteWork':
          endpoint = 'api/Operations/Employee/GetRemoteWorkData';
          break;
        default:
          endpoint = 'api/Operations/Employee/GetViolationsData';
      }

      const response = await Post({
        url: `${apiPath}${endpoint}`,
        data: baseParams,
      });
      return { tab, data: response?.data?.data };
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

export const fetchDailyOverview = createAsyncThunk(
  'dashboard/fetchDailyOverview',
  async (_, thunkAPI) => {
    try {
      // const res = await Get({ url: `${apiPath}Endpoint` });
      return dummyDailyOverview;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

export const fetchCalendarData = createAsyncThunk(
  'dashboard/fetchCalendarData',
  async (_, { rejectWithValue }) => {
    try {
      const data = {
        days: [
          { date: '2025-08-01', status: 'remote-work', type: '8.5 hrs' },
          { date: '2025-08-02', status: 'Weekend' },
          { date: '2025-08-03', status: 'Weekend' },
          // { date: '2025-08-04', status: 'remote-work', type: '9 hrs' },
          { date: '2025-08-04', status: 'violation', type: '9 hrs' },
          { date: '2025-08-05', status: 'remote-work', type: '8 hrs' },
          { date: '2025-08-06', status: 'remote-work', type: '9.5 hrs' },
          { date: '2025-08-07', status: 'remote-work', type: '8 hrs' },
          { date: '2025-08-08', status: 'remote-work', type: '7.5 hrs' },
          { date: '2025-08-09', status: 'Weekend' },
          { date: '2025-08-10', status: 'Weekend' },
          { date: '2025-08-11', status: 'remote-work', type: '8 hrs' },
          { date: '2025-08-12', status: 'remote-work', type: '9 hrs' },
          { date: '2025-08-13', status: 'remote-work', type: '8.5 hrs' },
          { date: '2025-08-14', status: 'remote-work', type: '7 hrs' },
          { date: '2025-08-15', status: 'remote-work', type: '9 hrs' },
          { date: '2025-08-16', status: 'Weekend' },
          { date: '2025-08-17', status: 'Weekend' },
          { date: '2025-08-18', status: 'remote-work', type: '8 hrs' },
          { date: '2025-08-19', status: 'annual-leave', type: 'AL' },
          { date: '2025-08-20', status: 'annual-leave', type: 'AL' },
          { date: '2025-08-21', status: 'remote-work', type: '9.5 hrs' },
          { date: '2025-08-22', status: 'remote-work', type: '8 hrs' },
          { date: '2025-08-23', status: 'Weekend' },
          { date: '2025-08-24', status: 'Weekend' },
          { date: '2025-08-25', status: 'leave', type: '9.5 hrs' },
          { date: '2025-08-26', status: 'remote-work', type: '7.5 hrs' },
          { date: '2025-08-27', status: 'remote-work', type: '8 hrs' },
          { date: '2025-08-28', status: 'remote-work', type: '9 hrs' },
          { date: '2025-08-29', status: 'absent-by-policy', type: 'Holidays' },
          { date: '2025-08-30', status: 'Weekend' },
          { date: '2025-08-31', status: 'Weekend',},
          // { date: '2025-08-31', status: 'absent-by-policy', type: 'Holidays' },
        ],
      };
      return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const dashboardSlice = createSlice({
  name: 'dashboard',
  initialState,
  reducers: {
    clearEmployeeDashboardData: (state, action) => {
      state.loading = false;
      state.error = '';
      state.dashboardDayDetailsItem = {};
    },
    clearNotificationDashboard: (state, action) => {
      state.loading = false;
      state.error = '';
      state.notification = {};
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchDashBoardDetails.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchDashBoardDetails.fulfilled, (state, action) => {
        state.loading = false;
        state.dashBoardDetails = action.payload;
        state.error = '';
      })
      .addCase(fetchDashBoardDetails.rejected, (state, action) => {
        state.loading = false;
        state.dashBoardDetails = action.payload;
        state.error = action.payload ?? 'An error occurred';
      });

    builder
      .addCase(GetEmployeeDashboardData.pending, (state) => {
        state.loading = true;
        state.dashboardDetailsItem = {};
      })
      .addCase(GetEmployeeDashboardData.fulfilled, (state, action) => {
        state.loading = false;
        state.dashboardDetailsItem = action.payload;
        // if (Object.keys(state.dashboardBasicDetails).length === 0) {
        state.dashboardBasicDetails = action.payload?.daysDetails;
        // }
        state.error = '';
      })
      .addCase(GetEmployeeDashboardData.rejected, (state, action) => {
        state.loading = false;
        state.dashboardDetailsItem = {};
        state.error = action.payload ?? 'An error occurred';
      });

    builder
      .addCase(MoveGateTransactionToReaderTransaction.pending, (state) => {
        state.loading = true;
        state.dashboardDetailsItem = {};
        state.notification = 0;
      })
      .addCase(
        MoveGateTransactionToReaderTransaction.fulfilled,
        (state, action) => {
          state.loading = false;
          state.notification = {
            show: true,
            code: action?.payload?.errCode ?? '500',
          };
          state.error = '';
        }
      )
      .addCase(
        MoveGateTransactionToReaderTransaction.rejected,
        (state, action) => {
          state.loading = false;
          state.notification = 500;
          state.error = action.payload ?? 'An error occurred';
        }
      );

    builder
      .addCase(GetEmployeeDashboardDayDetails.pending, (state) => {
        state.loading = true;
        state.dashboardDayDetailsItem = {};
      })
      .addCase(GetEmployeeDashboardDayDetails.fulfilled, (state, action) => {
        state.loading = false;
        state.dashboardDayDetailsItem = action.payload;
        state.error = '';
      })
      .addCase(GetEmployeeDashboardDayDetails.rejected, (state, action) => {
        state.loading = false;
        state.dashboardDayDetailsItem = {};
        state.error = action.payload ?? 'An error occurred';
      });

    builder
      .addCase(GetCardPopupData.pending, (state) => {
        state.loading = true;
        state.dashboardPopUpData = [];
      })
      .addCase(GetCardPopupData.fulfilled, (state, action) => {
        state.loading = false;
        state.dashboardPopUpData = action.payload;
        state.error = '';
      })
      .addCase(GetCardPopupData.rejected, (state, action) => {
        state.loading = false;
        state.dashboardPopUpData = [];
        state.error = action.payload ?? 'An error occurred';
      });
    builder
      .addCase(fetchEmployeeDetails.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchEmployeeDetails.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchEmployeeDetails.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || 'Failed to fetch employee data';
      });
    builder
      .addCase(fetchDashboardCard.pending, (state) => {
        state.dashboardCard.loading = true;
        state.dashboardCard.error = null;
      })
      .addCase(fetchDashboardCard.fulfilled, (state, action) => {
        state.dashboardCard.loading = false;
        state.dashboardCard.data = action.payload;
      })
      .addCase(fetchDashboardCard.rejected, (state, action) => {
        state.dashboardCard.loading = false;
        state.dashboardCard.error = action.error.message;
      });
    builder
      .addCase(fetchDailyOverview.pending, (state) => {
        state.dailyOverview.loading = true;
      })
      .addCase(fetchDailyOverview.fulfilled, (state, action) => {
        state.dailyOverview.loading = false;
        state.dailyOverview.data = action.payload;
      })
      .addCase(fetchDailyOverview.rejected, (state, action) => {
        state.dailyOverview.loading = false;
        state.dailyOverview.error = action.payload;
      });
    builder
      .addCase(fetchQuickActionsData.pending, (state, action) => {
        const tab = action.meta.arg.tab;
        state.quickActions[tab].loading = true;
        state.quickActions[tab].error = null;
        state.quickActions.currentTab = tab;
      })
      .addCase(fetchQuickActionsData.fulfilled, (state, action) => {
        const { tab, data } = action.payload;
        state.quickActions[tab].data = data;
        state.quickActions[tab].loading = false;
      })
      .addCase(fetchQuickActionsData.rejected, (state, action) => {
        const tab = action.meta.arg.tab;
        state.quickActions[tab].loading = false;
        state.quickActions[tab].error = action.payload;
      });
    builder
      .addCase(fetchCalendarData.pending, (state) => {
        state.calendarData.loading = true;
        state.calendarData.error = null;
      })
      .addCase(fetchCalendarData.fulfilled, (state, action) => {
        state.calendarData.loading = false;
        state.calendarData.data = action.payload;
        // state.calendarData.error = null;
      })
      .addCase(fetchCalendarData.rejected, (state, action) => {
        state.calendarData.loading = false;
        state.calendarData.error =
          action.payload ?? 'Failed to fetch calendar data';
      });
  },
});

export const selectChartData = (state) => {
  const data = state.dashboardDetails?.data;
  return [
    { name: 'Present', value: data?.presentPercentage || 0, color: '#3E57E8' },
    { name: 'Absent', value: data?.absentPercentage || 0, color: '#D3DCE6' },
  ];
};

export const { clearEmployeeDashboardData, clearNotificationDashboard } =
  dashboardSlice.actions;
export default dashboardSlice.reducer;
